<template>
  <el-dialog
    :visible.sync="visible"
    width="30%"
    :show-close="false"
    :close-on-click-modal="false"
    custom-class="reward-dialog"
  >
    <div class="reward-content">
      <!-- <img src="@/assets/icon_reward.png" class="reward-icon"> -->
      <div class="reward-title">签到成功</div>
      <div class="reward-desc">恭喜您获得</div>
      <div class="reward-amount">
        <span class="amount">{{ rewardAmount }}</span>
        <span class="type">{{ rewardTypeText }}</span>
      </div>
    </div>
    <div class="dialog-footer">
      <el-button type="primary" @click="handleClose">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'RewardDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    todayReward: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    rewardAmount() {
      return this.todayReward.signin_reward || 0
    },
    rewardTypeText() {
      return this.todayReward.reward_type == 2 ? '积分' : '代金券'
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="less" scoped>
.reward-dialog {
  .reward-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    
    .reward-icon {
      width: 80px;
      height: 80px;
      margin-bottom: 20px;
    }
    
    .reward-title {
      font-size: 24px;
      color: #333;
      font-weight: bold;
      margin-bottom: 10px;
    }
    
    .reward-desc {
      font-size: 16px;
      color: #666;
      margin-bottom: 20px;
    }
    
    .reward-amount {
      display: flex;
      align-items: center;
      gap: 10px;
      
      .amount {
        font-size: 32px;
        color: #3C9C8F;
        font-weight: bold;
      }
      
      .type {
        font-size: 16px;
        color: #666;
      }
    }
  }
  
  .dialog-footer {
    text-align: center;
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    .el-button {
      width: 120px;
      height: 40px;
      background: #3C9C8F;
      border: none;
      
      &:hover {
        background: #2d7a6f;
      }
    }
  }
}
</style> 